module.exports = __webpack_public_path__ + "media/src/images/registration/temporary_registration_icon-d3647e558e1ab25549ab824a93c95aca.svg";